import { useParams } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import MobileForm from "../../../components/MobileForm";

const AIWO = () => {
  const { version } = useParams();
  const useValidation = require(`./v${version}/useValidation`).default;
  const background = require(`./v${version}/background.png`);
  const fields = require(`./v${version}/fields.json`);
  const { width: bgWidth, height: bgHeight } = require(`./v${version}/dimensions.json`);

  const width = document.documentElement.clientWidth;
  const ratio = width / bgWidth;
  const newHeight = bgHeight * ratio;

  return (
    <MobileForm
      type="aiwo"
      version={version}
      width={width}
      height={newHeight}
      useValidation={useValidation}
      background={background}
      fields={fields}
    />
  );
};

const Page = () => {
  const { PrivateContent } = useAuth();

  return (
    <PrivateContent title="Attic Insulation Work Order Form">
      <AIWO />
    </PrivateContent>
  );
};

export default Page;
